<template>
  <div class="cover">
    <div class="toast" role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-header">
        <svg 
          class="bi bi-info-circle-fill" 
          :class="{ 'info': getToastData.state === 0, 'danger': getToastData.state === 1, 'success': getToastData.state === 2 }" 
          width="1em" 
          height="1em" 
          viewBox="0 0 16 16" 
          fill="currentColor" 
          xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
        </svg>
        <strong class="mr-auto ml-1">{{ status }}</strong>
        <small>{{ new Date().getHours() }}:{{  getMinutes }}</small>
        <button type="button" @click="close" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="toast-body">
        {{ getToastData.text }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  created() {
    setTimeout(() => { this.close() }, 3000)
  },
  computed: {
    ...mapGetters(['getToastData']),
    status: function() {
      if (this.getToastData.state === 0) return "Информация"
      if (this.getToastData.state === 1) return "Ошибка"
      if (this.getToastData.state === 2) return "Успешно"
      return ''
    },
    getMinutes: function() {
      const min = new Date().getMinutes()

      if (min < 10) return "0" + min
      return min
    }
  },
  methods: {
    close() {
      this.$store.commit('setShowToast', false)
    }
  }
}
</script>

<style scoped>
  .cover {
    position: fixed;
    right: 10px;
    top: 100px;
    z-index: 100;
  }
  .toast {
    opacity: 1;
  }
  .danger {
    color: red;
  }
  .info {
    color: orange;
  }
  .success {
    color: green;
  }
</style>
